import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-encryption-settings',
  templateUrl: './encryption-settings.component.html',
  styleUrls: ['./encryption-settings.component.scss']
})
export class EncryptionSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
